<template>
<w-sliding-popup ref="slidingPopup" :title="title" width="600px" @close="closed" class="dashboard-setting-popup">
  <div slot="content" style="height: calc(100% - 10px);" v-loading="isLoading">
    <el-form v-show="activeType === 'basic'" :model="data" :rules="rules" ref="form">
      <div class="mr-b25">
        <el-row type="flex" justify="space-between" align="middle" class="title-bar">
          <h3 style="line-height:0">기본정보</h3>
          <div class="title-bar__btns">
            <el-button type="primary" :disabled="isDefaultDashboard" @click="onUploadClick">템플릿 업로드</el-button>
            <el-button :disabled="isDefaultDashboard" @click="onImportClick">불러오기</el-button>
          </div>
        </el-row>
        <el-row type="flex" :gutter="10">
          <el-col :span="12">
            <el-form-item label="대시보드 그룹">
              <el-select v-model="data.dashboardGroupId" style="width: 100%;" :disabled="type === DashboardConst.SET_TYPE.ADD || isDefaultDashboard">
                <el-option v-for="item in dashboardGroupList" :key="item.dashboardGroupId" :label="item.dashboardGroupName" :value="item.dashboardGroupId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="대시보드명" prop="dashboardName">
              <el-input v-model="data.dashboardName" :disabled="isDefaultDashboard" :maxlength="64" placeholder="대시보드명을 입력해주십시오."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="대시보드 설명">
            <el-input resize="none" type="textarea" :rows="5" v-model="data.dashboardDesc" :disabled="isDefaultDashboard" placeholder="대시보드 설명을 입력해주십시오."></el-input>
          </el-form-item>
        </el-row>
      </div>
      <div class="mr-b25" v-if="data.dashboardType === DashboardConst.DASHBOARD_TYPE.COORD">
        <h3 class="title-bar" style="line-height:0">화면정보</h3>
        <el-row type="flex" :gutter="10">
          <el-col :span="12">
            <el-form-item label="너비">
              <el-input-number v-model="data.width" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="높이">
              <el-input-number v-model="data.height" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="10">
          <el-col :span="12">
            <el-form-item label="배경">
              <el-select v-model="data.bgType" style="width: 100%;">
                <el-option label="색상" :value="DashboardConst.BACKGROUND_TYPE.COLOR"></el-option>
                <el-option label="이미지" :value="DashboardConst.BACKGROUND_TYPE.IMAGE"></el-option>
                <el-option label="애니메이션" :value="DashboardConst.BACKGROUND_TYPE.ANIMATION"></el-option>
                <el-option label="그라데이션" :value="DashboardConst.BACKGROUND_TYPE.GRADIENT"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="종류" v-if="data.bgType === DashboardConst.BACKGROUND_TYPE.ANIMATION">
              <el-radio-group v-model="data.aniOptions.type" style="width: 100%;" @change="onAnimationTypeChange">
                <el-radio-button :label="DashboardConst.BACKGROUND_ANIMATION_TYPE.PARTICLE"></el-radio-button>
                <el-radio-button :label="DashboardConst.BACKGROUND_ANIMATION_TYPE.BUBBLE"></el-radio-button>
                <el-radio-button :label="DashboardConst.BACKGROUND_ANIMATION_TYPE.STAR"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="배경/오브젝트 색상" v-if="data.bgType === DashboardConst.BACKGROUND_TYPE.ANIMATION">
              <el-row type="flex" :gutter="5" style="width: 100%">
                <el-col :span="12">
                  <w-color-field v-model="data.aniOptions.backgroundColor"></w-color-field>
                </el-col>
                <el-col :span="12">
                  <w-color-field v-model="data.aniOptions.color"></w-color-field>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="색상" v-if="data.bgType === DashboardConst.BACKGROUND_TYPE.GRADIENT">
              <w-gradient-setting-form v-model="data.aniOptions.gradientColors"></w-gradient-setting-form>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="색상" v-if="data.bgType === DashboardConst.BACKGROUND_TYPE.COLOR">
              <w-color-field v-model="data.bgColor" :showAlpha="true"></w-color-field>
            </el-form-item>
            <el-form-item label="이미지" v-if="data.bgType === DashboardConst.BACKGROUND_TYPE.IMAGE">
              <w-image-select-field v-model="data.customimageId"/>
            </el-form-item>
            <el-form-item label="미리보기" v-if="data.bgType === DashboardConst.BACKGROUND_TYPE.ANIMATION || data.bgType === DashboardConst.BACKGROUND_TYPE.GRADIENT">
              <el-row type="flex" style="width: 100%; border: 1px solid #c0c4cc;">
                <div style="width: 100%; height: 138px;">
                  <w-particle-background :options="data.aniOptions" v-if="data.bgType === DashboardConst.BACKGROUND_TYPE.ANIMATION"></w-particle-background>
                  <w-gradient-background :options="data.aniOptions" v-else-if="data.bgType === DashboardConst.BACKGROUND_TYPE.GRADIENT"></w-gradient-background>
                </div>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div>
        <h3 class="title-bar" style="line-height:0">기타정보</h3>
        <el-row type="flex" :gutter="10">
          <el-col :span="12">
            <el-form-item :label="refreshTimerSetLabel">
              <el-select v-model="data.refreshTimer" style="width: 100%;">
                <el-option label="5" :value="5"></el-option>
                <el-option label="10" :value="10"></el-option>
                <el-option label="30" :value="30"></el-option>
                <el-option label="60" :value="60"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="공개여부">
              <el-select v-model="data.openFlag" :disabled="isDefaultDashboard" style="width: 100%;">
                <el-option label="공개" value="Y"></el-option>
                <el-option label="비공개" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div v-if="activeType === 'upload'" style="height: 100%;">
      <div class="goback-small c-pointer l-align">
        <i class="fal fa-arrow-left" @click="onBackClick"></i> 대시보드 템플릿 업로드
      </div>
      <w-dashboard-upload-form v-model="uploadData" style="height: calc(100% - 38px);"></w-dashboard-upload-form>
    </div>
    <div v-if="activeType === 'import'" style="height: 100%;">
      <div class="goback-small c-pointer l-align">
        <i class="fal fa-arrow-left" @click="onBackClick"></i> 대시보드 불러오기
      </div>
      <w-dashboard-import-form v-model="importData" :dashboard-type="data.dashboardType" style="height: calc(100% - 38px);"></w-dashboard-import-form>
    </div>
  </div>
  <el-row slot="footer">
    <el-col :span="24">
      <el-row type="flex" justify="center" align="middle" v-show="activeType === 'basic'">
        <el-button class="mr-r4" size="large" type="solid" @click="onSaveClick">저장</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </el-row>
      <el-row type="flex" justify="center" align="middle" v-show="activeType === 'upload'">
        <el-button class="mr-r4" size="large" type="solid" @click="onUploadOkClick">확인</el-button>
        <el-button size="large" @click="onBackClick">취소</el-button>
      </el-row>
      <el-row type="flex" justify="center" align="middle" v-show="activeType === 'import'">
        <el-button class="mr-r4" size="large" type="solid" @click="onImportOkClick">확인</el-button>
        <el-button size="large" @click="onBackClick">취소</el-button>
      </el-row>
    </el-col>
  </el-row>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';

import { cloneDeep, find, remove, isEmpty, assign } from 'lodash';

import DashboardAPI from '@/api/dashboard/common';

import DashboardConst from '@/constants/dashboard';

import WColorField from '@/components/form/ColorField';

import WDashboardUploadForm from '@/views/dashboard/components/form/DashboardUploadForm';
import WDashboardImportForm from '@/views/dashboard/components/form/DashboardImportForm';
import WImageSelectField from '@/views/dashboard/components/ImageSelectField';
import WGradientSettingForm from '@/views/dashboard/components/form/GradientSettingForm';

import WParticleBackground from '@/views/dashboard/components/frame/ParticleBackground';
import WGradientBackground from '@/views/dashboard/components/frame/GradientBackground';

import BackgroundOption from '@/views/dashboard/data/background-option';

export default {
  name: 'WDashboardSettingPopup',
  components: {
    WDashboardUploadForm,
    WDashboardImportForm,
    WColorField,
    WImageSelectField,
    WGradientSettingForm,
    WParticleBackground,
    WGradientBackground,
  },
  data() {
    return {
      DashboardConst,
      isLoading: false,
      dashboardGroupList: [],
      type: DashboardConst.SET_TYPE.ADD,
      activeType: 'basic',
      orgData: {},
      data: {},
      uploadData: {},
      importData: null,
      rules: {
        dashboardName: [
          {
            required: true,
            message: '대시보드명을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    refreshTimerSetLabel() {
      if (this.data.dashboardType === DashboardConst.DASHBOARD_TYPE.GRID) {
        return '전체화면 슬라이드 갱신주기(초)';
      }
      return '데이터 갱신주기(초)';
    },
    isDefaultDashboard() {
      return this.data && this.data.defaultFlag === 'Y';
    },
    /**
     * 팝업창 타이틀
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    title() {
      let title = '';

      if (this.type === DashboardConst.SET_TYPE.ADD) {
        title = '대시보드 추가';
      } else if (this.type === DashboardConst.SET_TYPE.EDIT) {
        title = '대시보드 수정';
      }

      return title;
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.DASHBOARD_SET, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.DASHBOARD_SET, this.open);
  },
  methods: {
    /**
     * 템플릿 업로드 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onUploadClick() {
      this.activeType = 'upload';
    },
    /**
     * 불러오기 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onImportClick() {
      this.activeType = 'import';
    },
    /**
     * 대시보드 템플릿 업로드 확인 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onUploadOkClick() {
      if (isEmpty(this.uploadData)) {
        this.$message(msgUtil.getCustomMsgData('대시보드 템플릿 파일을 등록해주십시오.'));
      } else {
        const data = new FormData();
        data.append('file', this.uploadData.raw);

        this.isLoading = true;
        // 업로드한 템플릿 파일 파싱 결과 응답
        DashboardAPI.getUploadDashboardInfoOnTree(data).then((response) => {
          this.isLoading = false;

          const result = response.data;

          if (!result.success || result.data.dashboardInfo.dashboardType !== this.data.dashboardType) {
            this.$message(msgUtil.getCustomMsgData('대시보드 템플릿 파일 업로드를 실패하였습니다.'));
          } else {
            assign(this.data, result.data.dashboardInfo, {
              widgetList: result.data.widgetInfo,
            });
            this.onBackClick();
          }
        });
      }
    },
    /**
     * 대시보드 불러오기 확인 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onImportOkClick() {
      if (isEmpty(this.importData)) {
        this.$message(msgUtil.getCustomMsgData('대시보드를 선택해주십시오.'));
      } else {
        this.isLoading = true;

        if (this.importData.dashboardId) { // 기존 대시보드, 공유 대시보드
          DashboardAPI.getImportDashboardInfoOnTree(this.importData.dashboardId).then((response) => {
            this.isLoading = false;

            const result = response.data;

            if (result.success) {
              assign(this.data, result.data.dashboardInfo, {
                widgetList: result.data.widgetInfo,
              });
              this.onBackClick();
            } else {
              this.$message(msgUtil.getCustomMsgData('대시보드 조회를 실패하였습니다.'));
            }
          });
        } else if (this.importData.templateFile) { // 템플릿 대시보드
          DashboardAPI.getTemplateDashboardInfoOnTree(this.importData.templateFile).then((response) => {
            this.isLoading = false;

            const result = response.data;

            if (result.success) {
              assign(this.data, result.data.dashboardInfo, {
                widgetList: result.data.widgetInfo,
              });
              this.onBackClick();
            } else {
              this.$message(msgUtil.getCustomMsgData('템플릿 대시보드 조회를 실패하였습니다.'));
            }
          });
        }
      }
    },
    /**
     * 되돌아가기 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onBackClick() {
      this.uploadData = {};
      this.importData = null;
      this.activeType = 'basic';
    },
    /**
     * 저장 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onSaveClick() {
      // 유효성 검사
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.data.label = this.data.dashboardName;

          // Object를 String으로 변환시켜야 저장할 때 에러가 안난다.
          if (typeof this.data.aniOptions === 'object') {
            this.data.aniOptions = JSON.stringify(this.data.aniOptions);
          }

          if (this.type === DashboardConst.SET_TYPE.ADD) {
            this.orgData.children.push(cloneDeep(this.data));
          } else {
            const oldDashboardGroupId = this.orgData.dashboardGroupId;
            const newDashboardGroupId = this.data.dashboardGroupId;
            const dashboardType = this.data.dashboardType;

            assign(this.orgData, this.data);

            // 대시보드 그룹이 변경되었으면, 트리에 반영하도록한다.
            if (oldDashboardGroupId !== newDashboardGroupId) {
              const oldGroup = find(this.$store.getters.getDashboardTree(dashboardType), ['dashboardGroupId', oldDashboardGroupId]);
              const newGroup = find(this.$store.getters.getDashboardTree(dashboardType), ['dashboardGroupId', newDashboardGroupId]);
              oldGroup.children.splice(oldGroup.children.indexOf(this.orgData), 1);
              newGroup.children.push(cloneDeep(this.orgData));
            }
          }

          this.close();
        } else {
          return false;
        }

        return true;
      });
    },
    /**
     * 팝업창을 연다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} type [description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    open(type, data) {
      this.resetForm();

      // 2018.10.15 : 그룹 리스트에서 기본대시보드그룹 제외처리 (ryunnnne)
      this.dashboardGroupList = remove(cloneDeep(this.$store.getters.getDashboardTree(data.dashboardType)), (v) => v.defaultFlag === 'N');

      this.type = type;
      this.orgData = data;

      if (this.type === DashboardConst.SET_TYPE.ADD) {
        this.data = this.createData();
      } else {
        this.data = cloneDeep(this.orgData);
      }

      if (typeof this.data.aniOptions === 'string') {
        // FIXME: aniOptions 속성이 추가되면 기존에 그려진 대시보드에는 그 속성이 없어서 에러가 발생한다.
        // 그래서 기본 속성에 덮어씌우는 하는 방식으로 처리는했는데, 유지보수성이 떨어져서 더 좋은 방법이 있으면 좋을듯..
        // this.data.aniOptions = JSON.parse(this.data.aniOptions);
        this.data.aniOptions = assign(this.createData().aniOptions, JSON.parse(this.data.aniOptions));
      }

      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업창을 닫는다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 팝업창 닫힌 후 호출 됨
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    closed() {
      this.type = DashboardConst.SET_TYPE.ADD;
      this.activeType = 'basic';
      this.orgData = {};
      this.data = {};
      this.uploadData = {};
      this.importData = null;
    },
    /**
     * 폼 초기화
     * @author KangBonghun(toto1323)
     */
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    createData() {
      return {
        label: '',
        dashboardGroupId: this.orgData.dashboardGroupId,
        dashboardName: '',
        dashboardDesc: '',
        width: DashboardConst.COORD_LAYOUT_OPTION.DEFAULT_W,
        height: DashboardConst.COORD_LAYOUT_OPTION.DEFAULT_H,
        bgType: DashboardConst.BACKGROUND_TYPE.COLOR,
        bgColor: 'rgba(255, 255, 255, 0)',
        customimageId: null,
        dashboardType: this.orgData.dashboardType,
        refreshTimer: 60,
        openFlag: 'Y',
        itemLevel: 'NODE',
        defaultFlag: 'N',
        leaf: true,
        aniOptions: {
          type: DashboardConst.BACKGROUND_ANIMATION_TYPE.PARTICLE,
          backgroundColor: '#ffffff',
          color: '#555555',
          gradientColors: cloneDeep(BackgroundOption.gradient[0]),
        },
      };
    },
    onAnimationTypeChange(type) {
      const info = BackgroundOption[type];

      if (info) {
        this.data.aniOptions.color = info.color;
        this.data.aniOptions.backgroundColor = info.backgroundColor;
      }
    },
  },
};
</script>
<style lang="scss">
.dashboard-setting-popup {
  .el-scrollbar__view {
    height: 100%;
  }

  .body-content {
    height: 100%;
  }
  .title {
    &-bar {
      &__btns {
        .el-button--mini {
          -webkit-padding-before: 7px !important;
          padding-top: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/DashboardSettingPopup.vue